<template>
  <v-container class="grid-list-md pa-0 mb-5">
    <v-flex xs12 class="text-xs-right">
      <v-tooltip :disabled="!showTooltip" top>
        <v-btn
          style="margin-bottom: -6px;"
          round
          slot="activator"
          color="secondary"
          @click="addMedicaidRecord">
          <v-icon dark>mdi-plus</v-icon>
          Add Procedure
        </v-btn>
        <span>Add procedure</span>
      </v-tooltip>
    </v-flex>
    <v-flex xs12 v-for="(record, index) in student.form.medicaid" :key="index">
      <medicaid-repeatable
        :v="v"
        :student="student"
        :medicaidArray="medicaidArray"
        :showTooltip="showTooltip"
        :index="index"
        :record="record"
        v-on:delete:record="removeMedicaidRecord(index)"
        v-on:calculate:minutes="calculateMinutes">
      </medicaid-repeatable>
    </v-flex>
  </v-container>
</template>

<script>
import MedicaidRepeatable from '@/components/service-log/form/medicaid-repeatable';
import * as Constants from '@/constants';

export default {
  name: 'MedicaidInformation',
  props: ['student', 'medicaidArray', 'showTooltip', 'v'],
  components: {
    MedicaidRepeatable
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  methods: {
    calculateMinutes() {
      const absentType = this.student.form.serviceInformation.absentType;
      const serviceDelivered = this.student.form.serviceInformation.serviceDelivered;
      let totalReimbursable = 0;
      let total = 0;
      if (!Constants.IS_ABSENT(absentType)) {
        const medicaid = this.student.form.medicaid;
        medicaid.forEach((m) => {
          total += Number(m.minutes);
          if (Constants.IS_SD_REIMBURSABLE(serviceDelivered) && m.procedure && m.procedure.procedureId && m.procedure.reimbursable) {
            totalReimbursable += Number(m.minutes);
          }
        });
      }
      this.student.form.totalMedicaidMinutes = total;
      this.student.form.totalReimbursableMinutes = totalReimbursable;
    },
    addMedicaidRecord() {
      this.student.form.medicaid.push(
        {
          minutes: '',
          procedureId: '',
          procedureName: ''
        }
      );
    },
    removeMedicaidRecord(index) {
      if (this.student.form.medicaid.length > 1) {
        this.student.form.medicaid.splice(index, 1);
      } else {
        this.student.form.medicaid = [
          {
            minutes: '',
            procedureId: '',
            procedureName: ''
          }
        ];
      }
      // recalculate total medicaid minutes
      this.calculateMinutes();
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/service-log/form/medicaid-information.vue